module.exports = __webpack_public_path__ + "media/bootstrap-icons/box-arrow-up-f1c29d90.svg";